<!--
  - TODO (cleanup): think if we can utilize this utility with other select from lister elements
-->
<template>
  <Dialog :expanderClass="'d-inline'" ref="dialogRef">
    <template #expander="{ openModal }">
      <ButtonCustomized secondary :label="btnTitle" :data-testid="dataTestId" @click="openModal" v-if="showBtn" />
      <button type="button" @click="openModal" v-if="!showBtn" class="add-link" :data-testid="dataTestId">{{ btnTitle }}</button>
    </template>
    <template #dialog.title>
      {{ dialogTitle }}
    </template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
      <div class="container">
        <SimpleEntityListingPage
          entityItemsNamePlural=""
          entityItemName="''"
          :areaAccessName="areaAccessName"
          :ItemsLister="ItemsLister"
          :selectMode=true
        />
        <div class="form-buttons">
          <ButtonCustomized label="Add" :data-testid="addButtonTestId || 'lister-dialog-add'" @click="onAdd" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from '../Dialog.vue';
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
import useListSelection from '@/components/ListingPages/ItemsLister/ItemsList/composables/listSelection';
import { ref } from 'vue';
const emit = defineEmits(['add']);
const props = defineProps({
  'showBtn': {
    type: Boolean,
    default: false
  },
  'dialogTitle': {
    type: String,
    default: 'Select'
  },
  'btnTitle': {
    type: String,
    default: 'Select'
  },
  'selectedItemsLinkBase': {
    type: String,
    required: false
  },
  'areaAccessName': {
    type: String,
    default: 'Administration'
  },
  'ItemsLister': {
    type: Object
  },
  'dataTestId': {
    type: String,
  },
  'addButtonTestId': {
    type: String,
  }
});

const dialogRef = ref();
defineExpose({
  open: () => dialogRef.value.openModal()
});

const {
  selectedItemsIds,
  selectedItems,
  clearItemsSelection
} = useListSelection({
  clearSelectionTriggerElement: document.body
});

async function onAdd() {
  const selectedItemsPrepared = selectedItems.map(item => ({
    name: item.name,
    id: item.id,
    ...(
      props.selectedItemsLinkBase
        ? { link: `${props.selectedItemsLinkBase}/${item.id}` }
        : {}
    )
  }));
  emit('add', selectedItemsPrepared);
  clearItemsSelection();
  dialogRef.value.closeModal()
}
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
}

.delete-item-form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.add-link {
  border: 0;
  cursor: pointer;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 6px;
  text-transform: uppercase;
  color: rgba(37, 41, 74, 0.5);
  font-weight: bold;
}

.add-link:hover {
  text-decoration: underline;
}


/* START: Lister Dialog Sizing Fix */
/* Help fix width & height of Lister Dialog */
.container { 
  @include x-large-devices-up {
    width: 70rem;
  }
  @media screen and (min-height: 1200px) and (max-height: 862px) {
    width: 48rem;
  }
}

:deep(.list-section-container) {
  height: fit-content;
  padding-bottom: 0;
}
/* END: Lister Dialog Sizing Fix */
</style>